import React from 'react';
import { Platform, Text } from 'react-native';
import styled from 'styled-components/native';
import Spacer from '../../components/Spacer';
import WellnessCategoryList, {
  WellnessCategory
} from '../../components/WellnessCategoryList';

const StyledView = styled.View`
  flex: 1;
  background-color: white;
  padding: 16px;
`;

const WellnessCategoryListScreen: React.FC = () => {
  const mockData: WellnessCategory[] = [
    {
      imageUrl:
        'https://drive.google.com/uc?id=1LrTgtB81mqTO8eRo4FcDQ0h-axX2PVJC',

      category: 'Weight'
    },
    {
      imageUrl:
        'https://drive.google.com/uc?id=1m9X5uUPjX3POIdlFCqgCIuYEECHplR4J',
      category: 'Sleep'
    },
    {
      imageUrl:
        'https://drive.google.com/uc?id=173ZWvz8gjiN-kaI_obgsXklvKgGfsLf3',
      category: 'Skin'
    },
    {
      imageUrl:
        'https://drive.google.com/uc?id=12f5x4-8D3o1pbrZ1ZIRnSVsdPlH6lDN4',
      category: 'Pain'
    },
    {
      imageUrl:
        'https://drive.google.com/uc?id=1i29q9WIW_G5JnSlvDJgLzkxCDRZlhYrk',
      category: 'Mood'
    },
    {
      imageUrl:
        'https://drive.google.com/uc?id=1ZBIJb-K8odviLpxIOXYhfJ_StKk5lgG8',
      category: 'Focus'
    }
  ];

  return (
    <StyledView>
      {Platform.OS === 'web' && <Spacer size={10} />}
      <WellnessCategoryList categories={mockData}></WellnessCategoryList>
    </StyledView>
  );
};

export default WellnessCategoryListScreen;
